module.exports = __webpack_public_path__ + "img/qrcode@2x.9c6fe4ea.png";